import React from "react";
import Tab from "../../../components/attributes/Tab";
import {
  SYMBOL_CURRENCY,
  TEXT_ACTIVE,
  TEXT_CONTACT_US,
  TEXT_MY_ORDERS,
  TEXT_PAST,
  TEXT_QUESTION_ABOUT_YOUR_ORDER,
  TEXT_ORDER,
} from "../../../utils/useConstants";

import OrderGetStyleStatus, {
  OPTIONS_STATUS_NEW,
} from "../functions/Order.GetStyleStatus";
import { useNavigate } from "react-router-dom";
import OrderGetPaymentImage, {
  OrderGetPaymentImageMain,
} from "../functions/Order.GetPaymentImage";
import {
  STYLE_BORDER_SECTION_ORDER,
  STYLE_BOTTOM_ORDER,
  STYLE_DATE_ORDER,
  STYLE_LINK_BLUE,
  STYLE_MAX_WIDTH_DESKTOP,
  STYLE_MIN_H_FULL,
  STYLE_ORDER_BG,
  STYLE_PADDING_NO_MB,
  STYLE_PAYMENT_ORDER,
  STYLE_SECTION_ORDER,
  STYLE_TITLE_ORDER_NAME,
  STYLE_TITLE_SEMIBOLD,
} from "../../../utils/useStyle";
import { ContextLanguage } from "../../../context/Context.Language";
import { STATE_CONSTANTS_STATUS } from "../../../utils/useConstantState";
import {
  FunctionFormatCurrency,
  FunctionGetDateNTimeFromDate,
} from "../../../utils/useFunction";
import ProgramGoBack from "../../task/render/Program.GoBack";
import Container from "../../../components/layouts/Container";
import { useIsMobile } from "../../../utils/useIsMobile";
import { MAPPING_DATE } from "../../basket/function/Busket.GenerateDate";

// const STATE_CONSTANTS = ["Active", "Past"];

// const TEST = ({ tab }) => {
//   const { language } = React.useContext(ContextLanguage);
//   if (tab === [STATE_CONSTANTS === "Active"]) {
//     return <div>{TEXT_ACTIVE[language]}</div>;
//   } else if (tab === [STATE_CONSTANTS === "Past"]) {
//     return <div>{TEXT_PAST[language]}</div>;
//   } else return " test";
// };

// export const STATE_CONSTANTS_STATUS = {
//   PROCESSING: "PROCESSING",
//   COMPLETED: "COMPLETED",
//   CANCELLED: "CANCELLED",
// };

const OrderMyOrder = ({ orders }) => {
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  // const STATE_CONSTANTS = [
  //   `${TEXT_ACTIVE[language]}`,
  //   `${TEXT_PAST[language]}`,
  // ];

  const navigate = useNavigate();
  // const [tab, setTab] = React.useState(STATE_CONSTANTS[0]);
  // const [thisOrders, setThisOrders] = React.useState([]);

  // React.useEffect(() => {
  //   let x = [];
  //   if (tab === STATE_CONSTANTS[0]) {
  //     x = orders.filter((order) => {
  //       return OPTIONS_STATUS_NEW.slice(0, 6)
  //         .map((x) => x.value)
  //         .includes(order.status);
  //     });
  //   }
  //   if (tab === STATE_CONSTANTS[1]) {
  //     x = orders.filter((order) => {
  //       return OPTIONS_STATUS_NEW.slice(6, OPTIONS_STATUS_NEW.length)
  //         .map((x) => x.value)
  //         .includes(order.status);
  //     });
  //   }

  //   setThisOrders(x);
  // }, [tab]);

  // React.useEffect(() => {
  //   setTab(STATE_CONSTANTS[0]);
  // }, [language]);

  return (
    <div
      className={` md:ordershadow flex flex-col min-h-screen md:min-h-full overflow-x-hidden mb-10 md:mb-0`}
    >
      <Container>
        <div className={`${STYLE_MAX_WIDTH_DESKTOP} ${STYLE_PADDING_NO_MB}  `}>
          <div
            style={{ minHeight: "calc(100dvh - 550px)" }}
            className={`${STYLE_ORDER_BG} `}
          >
            <ProgramGoBack
              onClick={() => {
                navigate("/");
              }}
              title={TEXT_MY_ORDERS[language]}
              textcolor=" "
            />
            <div className={``}>
              <div className="pt-4">
                {" "}
                {/* <Tab tabs={STATE_CONSTANTS} value={tab} setValue={setTab} /> */}
              </div>
              <div className=" ">
                {orders?.map((row, index) => {
                  const createNewDate = FunctionGetDateNTimeFromDate(
                    row.createdAt
                  );

                  const thisCreatedDate = `${
                    language === "TH"
                      ? MAPPING_DATE[createNewDate.day]
                      : createNewDate.day
                  }${language === "TH" ? `` : `,`} ${createNewDate.date}.${
                    createNewDate.month
                  }.${createNewDate.year}${
                    language === "TH" ? " เวลา " : ","
                  } ${createNewDate.hour}:${createNewDate.minute}`;
                  // console.log(row);
                  return (
                    <div
                      className={
                        " relative <40> " +
                        `${
                          index + 1 < orders?.length &&
                          STYLE_BORDER_SECTION_ORDER
                        }`
                      }
                    >
                      <div
                        onClick={() => {
                          navigate(`/MyOrders/${row?._id}`);
                        }}
                        className={STYLE_SECTION_ORDER}
                        key={`key-of-order-data-${index}`}
                      >
                        <div className="">
                          <div
                            className={`${STYLE_TITLE_ORDER_NAME(language)}`}
                          >
                            <div className="flex group-hover:underline break-all">
                              {TEXT_ORDER[language]} No. {row?.order_number}
                            </div>
                          </div>
                        </div>

                        <div className={`${STYLE_DATE_ORDER(language)} `}>
                          {thisCreatedDate} {language === "TH" && "น."}
                        </div>

                        <div className={`${STYLE_PAYMENT_ORDER} items-center`}>
                          <div className=" flex-none">
                            <OrderGetPaymentImageMain
                              input={row?.payment_method}
                            />
                          </div>
                          <div
                            className={`flex-shrink md:mt-[2px] ${STYLE_TITLE_SEMIBOLD(
                              language
                            )} `}
                          >
                            <span className="font-NotoSansThai">
                              {SYMBOL_CURRENCY}
                            </span>
                            {FunctionFormatCurrency(row?.total || 0)}
                          </div>
                        </div>
                        <div
                          className={`absolute ${
                            isMobile ? "bottom-2" : "bottom-9"
                          } right-2`}
                        >
                          <OrderGetStyleStatus input={row?.status} />
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          {!isMobile && (
            <div className="pt-8 bg-white rounded-b-xl">
              <div className={`${STYLE_BOTTOM_ORDER(language)}`}>
                {TEXT_QUESTION_ABOUT_YOUR_ORDER[language]}{" "}
                <span
                  onClick={() => navigate("/ContactUs")}
                  className={STYLE_LINK_BLUE}
                >
                  {TEXT_CONTACT_US[language]}
                </span>
              </div>
            </div>
          )}
        </div>
      </Container>
      {isMobile && (
        <div className={`${STYLE_BOTTOM_ORDER(language)}`}>
          {TEXT_QUESTION_ABOUT_YOUR_ORDER[language]}{" "}
          <span
            onClick={() => navigate("/ContactUs")}
            className={STYLE_LINK_BLUE}
          >
            {TEXT_CONTACT_US[language]}
          </span>
        </div>
      )}
    </div>
  );
};

export default OrderMyOrder;
